export default {
  workshop: {
    breadcrumbHome: 'Početna',
    breadcrumbSolutions: 'Rješenja',
    breadcrumbCurrent: 'Radionica i obrt',
    hero: {
      eyebrow: 'Radionica i obrt',
      title: 'Robusna sigurnosna tehnika za zahtjevne uvjete',
      lead: 'Prašina, vlaga, temperaturna kolebanja – radionice postavljaju posebne zahtjeve. Montiramo kamere koje to izdrže.',
    },
    areas: {
      title: 'Područja primjene u radionicama i obrtu',
      lead: 'Od radioničkog prostora do vanjskog dvorišta – osiguravamo vaše vrijedne alate, strojeve i vozila.',
      items: {
        '0': { title: 'Radionička hala', desc: 'Visoke hale sa strojevima trebaju robusne kamere dobre rezolucije – i pri teškom svjetlu.' },
        '1': { title: 'Radionički prostor', desc: 'Alati, rezervni dijelovi i aktivni poslovi: nadzor štiti vaš prostor i pojašnjava reklamacije.' },
        '2': { title: 'Zona utovara', desc: 'Utovar i istovar prilike su za krađu. Kamere na zoni utovara pouzdano dokumentiraju svaku radnju.' },
        '3': { title: 'Zona strojeva', desc: 'Moderna proizvodnja zahtijeva potpunu dokumentaciju procesa – i između strojeva.' },
        '4': { title: 'Dvorište i parkiralište', desc: 'Parkirana vozila, prikolice i materijal – dvorište treba kamere otporne na vremenske uvjete s dobrim noćnim vidom.' },
        '5': { title: 'Ured i uprava', desc: 'Ponude, računi i podaci kupaca su u uredu. Ni ovdje se sigurnost ne smije zanemariti.' },
      },
    },
    robust: {
      eyebrow: 'Robusnost',
      title: 'Građeno za tešku upotrebu',
      lead: 'Radionice nisu izložbeni prostori. Naše kamere su napravljene upravo za takva okruženja i birane za vaše uvjete.',
      items: {
        '0': { title: 'Visoka klasa zaštite', desc: 'Kućišta IP66 štite od prašine, prskanja i kiše – i pri stalnoj vanjskoj upotrebi.' },
        '1': { title: 'Otporno na temperaturu i vlagu', desc: 'Od ledenog skladišta do tople radionice: biramo kamere za svaki temperaturni raspon.' },
        '2': { title: 'Kućišta zaštićena od prašine', desc: 'U prašnjavim okruženjima posebna kućišta i brtve godinama drže optiku čistom i oštrom.' },
      },
    },
    maintenance: {
      eyebrow: 'Održavanje i skrb',
      title: 'Kako bi vaš sustav ostao pouzdan',
      lead: 'U prašnjavim i zahtjevnim okruženjima njega odlučuje o vijeku trajanja. Uz SSG Care vaš sustav ostaje stalno spreman.',
      list: {
        '0': 'Redovite provjere SSG Care – i izvan jamstva',
        '1': 'Čišćenje i vizualna provjera kućišta i objektiva',
        '2': 'Ažuriranja firmvera i sigurnosti prema potrebi',
        '3': 'Brza reakcija na smetnje ili kvarove',
        '4': 'Mogućnosti rezervnih dijelova i nadogradnje',
      },
      note: 'Napomena: zakonska dopuštenost videonadzora ovisi o slučaju. Savjetujemo vas, ne zamjenjujući pravni savjet.',
    },
    cta: {
      title: 'Vaša radionica zaslužuje siguran pogled',
      lead: 'Savjetujemo vas bez obveze koje kamere vaše okruženje podnosi i gdje najviše štite.',
      primary: 'Zakažite termin savjetovanja',
      secondary: 'Otkrijte SSG Care',
    },
  },
};